import React from 'react';
import './Stepper.scss';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import { Step } from './Stepper';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

type StepperProps = ReturnType<typeof mapStateToProps> & {
  step: number;
};

const Stepper: React.FC<StepperProps> = ({ step, isLoggedIn }) => {
  return (
    <div className="stepper">
      <div className="md-stepper-horizontal orange">
        <Step currentStep={step} stepIndex={0} title="Créneau" />
        <Step currentStep={step} stepIndex={1} title="Connexion" />
        <Step currentStep={step} stepIndex={2} title="Pour qui ?" />
      </div>
    </div>
  );
};

export default connect(mapStateToProps, null)(Stepper);
